import Vue from 'vue';
import Router from 'vue-router';
import Admin from './pages/admin.vue';
import Builds from './pages/builds.vue';
import Map from './pages/map.vue';
import Charts from './pages/charts.vue';
import Login from './pages/login.vue';
import MapsParse from './pages/maps-parser.vue';
import LevelsStatistic from './pages/levels-statistic.vue';
import TelemetryStatistic from './pages/telemetry/statistic.vue';
import TelemetryFeedback from './pages/telemetry/feedback.vue';
import TelemetryConfigStatistic from './pages/telemetry/config-statistic.vue';
import TelemetryFrogwaresPlaytests from './pages/telemetry/frogwares-playtests.vue';
import TelemetryHardwareStatistic from './pages/telemetry/hardware-statistic.vue';
import TelemetryMarketing from './pages/telemetry/marketing.vue';
import CombatTest from './pages/combat-test.vue';

import { createSandbox } from 'vue-kindergarten';
import RouteGoverness from './governesses/RouteGoverness';
import basePerimeter from './perimeters/base';
import store from './store';
import child from './child';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Builds,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }
    },
    {
      path: '/map',
      component: Map,
      meta: {
        layout: 'map-layout',
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }
    },
    {
      path: '/charts',
      component: Charts,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      },
      children: [
        {
          path: ':platform',
          component: () => import(/* webpackChunkName: "charts" */ './pages/charts/_platform.vue'),
        },
      ],
    },
    {
      path: '/telemetry/statistic',
      component: TelemetryStatistic,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      },
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "telemetry-statistic" */ './pages/telemetry/statistic/general.vue'),
        },
        {
          path: 'combat',
          component: () => import(/* webpackChunkName: "telemetry-statistic" */ './pages/telemetry/statistic/combat.vue'),
        },
        {
          path: 'items',
          component: () => import(/* webpackChunkName: "telemetry-statistic" */ './pages/telemetry/statistic/items.vue'),
        },
        {
          path: 'main-character',
          component: () => import(/* webpackChunkName: "telemetry-statistic" */ './pages/telemetry/statistic/main-character.vue'),
        },
        {
          path: 'ui',
          component: () => import(/* webpackChunkName: "telemetry-statistic" */ './pages/telemetry/statistic/ui.vue'),
        },
        {
          path: 'tension-beats',
          component: () => import(/* webpackChunkName: "telemetry-statistic" */ './pages/telemetry/statistic/tension-beats.vue'),
        },
      ],
    },
    {
      path: '/telemetry/feedback',
      component: TelemetryFeedback,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }
    },
    {
      path: '/telemetry/config-statistic',
      component: TelemetryConfigStatistic,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }
    },
    {
      path: '/telemetry/hardware-statistic',
      component: TelemetryHardwareStatistic,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }
    },
    {
      path: '/telemetry/frogwares-playtests',
      component: TelemetryFrogwaresPlaytests,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }
    },
    {
      path: '/telemetry/marketing/:buildTag',
      name: 'telemetry-marketing',
      component: TelemetryMarketing,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }
    },
    {
      path: '/levels-statistic',
      component: LevelsStatistic,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      },
    },
    {
      path: '/maps-parser',
      component: MapsParse,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }
    },
    {
      path: '/combat-test',
      component: CombatTest,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }
    },
    {
      path: '/admin',
      component: Admin,
      meta: {
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      },
      children: [
        {
          path: 'platforms',
          name: 'admin-platforms',
          component: () => import(/* webpackChunkName: "admin" */ './pages/admin/platforms.vue'),
        },
        {
          path: 'map',
          component: () => import(/* webpackChunkName: "admin" */ './pages/admin/map.vue'),
          children: [
            {
              path: 'global',
              name: 'admin-map-global',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/map/global.vue'),
            },
            {
              path: 'editor',
              name: 'admin-map-editor-category',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/map/editor.vue'),
            },
            {
              path: 'segments',
              name: 'admin-map-segments-category',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/map/segments.vue'),
            },
            {
              path: 'runtime',
              name: 'admin-map-runtime-category',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/map/runtime.vue'),
              children: [
                {
                  path: 'global',
                  name: 'admin-map-runtime-global',
                  component: () => import(/* webpackChunkName: "admin" */ './pages/admin/map/runtime/global.vue'),
                },
                {
                  path: 'custom',
                  name: 'admin-map-runtime-custom',
                  component: () => import(/* webpackChunkName: "admin" */ './pages/admin/map/runtime/custom.vue'),
                },
                {
                  path: 'llm-stats-categories',
                  name: 'admin-map-runtime-llm-stats-categories',
                  component: () => import(/* webpackChunkName: "admin" */ './pages/admin/map/runtime/llmStatsCategories.vue'),
                },
              ].map(child => ({ ...child, meta: { layout: 'admin-layout' } })),
            }
          ].map(child => ({ ...child, meta: { layout: 'admin-layout' } })),
        },
        {
          path: 'telemetry',
          name: 'admin-map-telemetry-category',
          component: () => import(/* webpackChunkName: "admin" */ './pages/admin/telemetry.vue'),
          children: [
            {
              path: 'timeline',
              name: 'admin-telemetry-timeline',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/telemetry/timeline.vue'),
            },
            {
              path: 'heatmap',
              name: 'admin-telemetry-heatmap',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/telemetry/heatmap.vue'),
            },
            {
              path: 'recalculation',
              name: 'admin-telemetry-recalculation',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/telemetry/recalculation.vue'),
            },
            {
              path: 'sessions',
              name: 'admin-telemetry-sessions',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/telemetry/sessions.vue'),
            },
            {
              path: 'feedback-actions',
              name: 'feedback-actions',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/telemetry/feedbackActions.vue'),
            },
            {
              path: 'encounters',
              name: 'encounters',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/telemetry/encounters.vue'),
            },
            {
              path: 'difficulty-levels',
              name: 'difficulty-levels',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/telemetry/difficultyLevels.vue'),
            }
          ].map(child => ({ ...child, meta: { layout: 'admin-layout' } })),
        },
        {
          path: 'multiproject',
          component: () => import(/* webpackChunkName: "admin" */ './pages/admin/multiproject.vue'),
          children: [
            {
              path: 'platforms',
              name: 'admin-multiproject-platforms',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/multiproject/platforms.vue'),
            },
            {
              path: 'projects',
              name: 'admin-multiproject-projects',
              component: () => import(/* webpackChunkName: "admin" */ './pages/admin/multiproject/projects.vue'),
            }
          ].map(child => ({ ...child, meta: {
            layout: 'admin-layout',
            perimeter: basePerimeter,
            perimeterAction: 'watch',
          }})),
        },
        {
          path: 'levels-references',
          component: () => import(/* webpackChunkName: "admin" */ './pages/admin/levelsReferences.vue'),
        },
        {
          path: 'engine-api',
          component: () => import(/* webpackChunkName: "admin" */ './pages/admin/engineApi.vue'),
        }
      ].map(child => ({ ...child, meta: {
        layout: 'admin-layout',
        perimeter: basePerimeter,
        perimeterAction: 'watch',
      }})),
    },
    {
      path: '/login',
      component: Login
    },
  ]
})

router.beforeEach((to, from, next) => {
  to.matched.some((routeRecord) => {
    const perimeter = routeRecord.meta.perimeter;
    const Governess = routeRecord.meta.governess || RouteGoverness;
    const action = routeRecord.meta.perimeterAction || 'route';

    if (perimeter) {
      try {
        const sandbox = createSandbox(child(store), {
          governess: new Governess(),
          perimeters: [
            perimeter,
          ],
        });

        return sandbox.guard(action, { to, from, next });
      } catch (err) {
        console.log(err)
      }
    }

    return next();
  });
});

export default router
